import $ from "jquery";

const searchOnHeader = () => {
  $(document).on("click", ".js-search", function (e) {
    e.preventDefault();
    $(".main-header .search-form").addClass("active");
  });

  $(document).on("click", ".main-header .search-btn-close", function (e) {
    e.preventDefault();
    $(".main-header .search-form").removeClass("active");
  });
};

try {
  searchOnHeader();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
